import { Flex, Image, Text } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { useEffect, useState } from 'react';
import { Button } from '../../ui';
import YaxleLogo from '../../assets/yaxleLogoBlue.png';

interface InventoryQuickAddLoadingBannerProps {
    isLoading: boolean;
    onSkip?: () => void;
}

const ELLIPSIS_FRAMES = ['.', '..', '...'];

const logoSpin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

const InventoryQuickAddLoadingBanner = ({
    isLoading,
    onSkip,
}: InventoryQuickAddLoadingBannerProps) => {
    const [ellipsisFrame, setEllipsisFrame] = useState(0);

    useEffect(() => {
        if (!isLoading) return;
        const timer = setInterval(() => {
            setEllipsisFrame((prev) => (prev + 1) % ELLIPSIS_FRAMES.length);
        }, 400);
        return () => clearInterval(timer);
    }, [isLoading]);

    if (!isLoading) return null;

    return (
        <Flex align="center" gap={3} pt={4} pb={1}>
            <Button size="sm" onClick={onSkip} flexShrink={0}>
                Skip
            </Button>
            <Flex
                align="center"
                gap={2}
                flex={1}
                px={3}
                py={2}
                bg="bg.surface"
                borderRadius="md"
                border="1px solid"
                borderColor="border.subtle"
            >
                <Image
                    src={YaxleLogo}
                    alt=""
                    h="20px"
                    w="20px"
                    flexShrink={0}
                    draggable={false}
                    animation={`${logoSpin} 2.8s linear infinite`}
                />
                <Text fontSize="sm" color="fg.muted">
                    Loading Item Details{ELLIPSIS_FRAMES[ellipsisFrame]}
                </Text>
            </Flex>
        </Flex>
    );
};

export default InventoryQuickAddLoadingBanner;
